const features = [
  {
    icon: 'fa-cogs',
    title: 'Soluciones integrales, no parches',
    description: 'Te ofrecemos paquetes completos que conectan infraestructura, marketing y energía. No tienes que coordinar con tres proveedores distintos, nosotros lo hacemos todo por ti.'
  },
  {
    icon: 'fa-brain',
    title: 'Asesoría especializada',
    description: 'Contamos con un equipo multidisciplinario: ingenieros, consultores, creativos y técnicos, que analizan tu situación y proponen la mejor solución adaptada a tus necesidades reales.'
  },
  {
    icon: 'fa-check-circle',
    title: 'Transparencia y confianza',
    description: 'Sin letras chiquitas, sin promesas vacías. Te hablamos claro desde el principio y te mantenemos informado durante todo el proceso.'
  },
  {
    icon: 'fa-rocket',
    title: 'Enfoque en resultados',
    description: 'Ya sea que busques más clientes, ahorrar en tu recibo de luz o mejorar tu conectividad, trabajamos para que veas resultados tangibles, no solo "bonita presentación".'
  },
  {
    icon: 'fa-tools',
    title: 'Calidad en productos y ejecución',
    description: 'Trabajamos con marcas confiables, herramientas certificadas y procesos profesionales en cada instalación, campaña o desarrollo.'
  },
  {
    icon: 'fa-leaf',
    title: 'Compromiso con el entorno',
    description: 'Impulsamos soluciones sostenibles, energías limpias y prácticas responsables para un impacto positivo en tu entorno.'
  },
  {
    icon: 'fa-handshake',
    title: 'Atención cercana y personalizada',
    description: 'Somos una empresa humana, que escucha, resuelve y acompaña. Aquí no eres un número, eres un proyecto importante para nosotros.'
  }
];

export default features;
